import { useEffect, useState } from 'react';
import useEventStore, { videos } from '../../stores/eventStore';
import styles from './video.module.scss';

export const Video = () => {
  const { activeTab } = useEventStore();
  const video = videos.find((e) => e.topic === activeTab);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <div className={styles.videoWrapper}>
        <div className={styles.videoTitle}>
          <span>活動花絮</span>
        </div>
        <div className={styles.videoContainer}>
          <iframe
            title={video.topic}
            key={video.src}
            src={video.src}
            allow='autoplay; fullscreen; picture-in-picture'
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </>
  );
};
